import { render, staticRenderFns } from "./MenuEditor.vue?vue&type=template&id=9bc909b8"
import script from "./MenuEditor.vue?vue&type=script&lang=ts"
export * from "./MenuEditor.vue?vue&type=script&lang=ts"
import style0 from "./MenuEditor.vue?vue&type=style&index=0&id=9bc909b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports